import { PrivacyFeedback } from './privacyFeedback';

const props = [];

export const PrivacyFeedbackDirective = (reactDirective) => reactDirective(PrivacyFeedback, props);
PrivacyFeedbackDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('privacyFeedback', PrivacyFeedbackDirective);
